module.exports = __webpack_public_path__ + "static/media/coin2.d1fa9941.png";